import Button from "@/components/button"
import { Image } from "antd"
import { FC } from "react"

const ArrowRightPrimaryIcon = "/icons/arrow-right-primary.svg";
import { useNavigate } from "react-router-dom"
import "./index.less"

const BackButton: FC = () => {
  const navigate = useNavigate()
  return (
    <Button
      onClick={() => navigate(-1)}
      icon={<Image src={ArrowRightPrimaryIcon} preview={false} />}
      btnText={"Back"}
      className={"back-button"}
    />
  )
}

export default BackButton
